import { getApiBaseUrl } from '../config/api';

/**
 * Fire-and-forget interaction log for admin analytics.
 */
export function recordInteraction(action, page = '', userId = 0) {
  const API_URL = getApiBaseUrl();
  if (!API_URL || !action) return;

  fetch(`${API_URL}/record_interaction.php`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    body: new URLSearchParams({
      action,
      page: page || (typeof window !== 'undefined' ? window.location.pathname : ''),
      user_id: userId || 0,
    }),
  }).catch(() => {
    // Ignore tracking failures
  });
}
